import { render, staticRenderFns } from "./BinLogs.vue?vue&type=template&id=5cbf1460"
import script from "./BinLogs.vue?vue&type=script&lang=js"
export * from "./BinLogs.vue?vue&type=script&lang=js"
import style0 from "./BinLogs.vue?vue&type=style&index=0&id=5cbf1460&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports